import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Layout, theme, Button, message, Input, Modal } from "antd";
import { UserOutlined, PlusOutlined } from "@ant-design/icons";
import LoadingOverlay from "react-loading-overlay-ts";

import TopBar from "../../components/TopBar";
import SideBar from "../../components/SideBar";
import FuneralCustomerTable from "../../components/Table/Funeral/FuneralCustomerTable";
import {
  AddFuneralCustomerModal,
  EditFuneralCustomerModal,
} from "../../components/ModalForm";

import { AuthContext } from "../../context/AuthContext";

import "../../styles/Groups.css";

import {
  getCompanyFuneralCustomersApi,
  addFuneralCustomerApi,
  editFuneralCustomerApi,
  searchFuneralCustomersApi,
} from "../../services/Funeral/FuneralCustomerApis";

const { Content } = Layout;
const { Search } = Input;

const FuneralCustomersPage: React.FC = () => {
  const [customers, setCustomers] = useState<any>([]);
  const [customer, setCustomer] = useState<any>({});
  const [filtered, setFiltered] = useState<any>([]);
  const [searchValue, setSearchValue] = useState<string>(
    () => sessionStorage.getItem("funeralCustomersSearch") || ""
  );
  const [show, setShow] = useState(false);
  const [update, setUpdate] = useState(false);
  const [isActive, setActive] = useState(true);
  const [confirmDelete, setConfirmDelete] = useState(false); // State for confirmation modal
  const [groupToDelete, setGroupToDelete] = useState<string>(""); // State for confirmation modal
  const [key, setKey] = useState<string>(""); // State for confirmation modal

  const { currentUser, currentGroup } = useContext(AuthContext);

  const navigate = useNavigate();

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const showModal = () => {
    setShow(!show);
    setUpdate(false);
  };

  const showEditModal = (data: any) => {
    setCustomer(data);
    setShow(!show);
    setUpdate(true);
  };

  const handleAdd = async (data: any) => {
    setActive(true);

    return await addFuneralCustomerApi(data, currentGroup)
      .then((res) => {
        setCustomers([...customers, res.data]);
        setActive(false);
        return res;
      })
      .catch((err) => {
        setActive(false);
        console.log(err);
      });
  };

  const handleUpdate = async (id: string, data: any) => {
    setActive(true);
    return await editFuneralCustomerApi(id, data)
      .then((res) => {
        const uppdatedCustomers = customers.map((customer: any) => {
          if (id === customer.id) {
            return { ...customer, ...res.data };
          }
          return customer;
        });
        setCustomers(uppdatedCustomers);
        setActive(false);
        return res;
      })
      .catch((err) => {
        setActive(false);
        console.log(err);
      });
  };

  const handleDelete = (id: string, key: string) => {
    setKey(key);
    setConfirmDelete(true);
    setGroupToDelete(id);
  };

  const onSearch = async (e: any) => {
    const value = e.target.value;
    setSearchValue(value);
    if (value) sessionStorage.setItem("funeralCustomersSearch", value);
    else sessionStorage.removeItem("funeralCustomersSearch");
    if (value !== "") {
      const result = await searchFuneralCustomersApi(String(currentGroup), value);
      const customerIds = new Set(customers.map((c: any) => c.id));
      setFiltered(result.data.filter((c: any) => customerIds.has(c.id)));
    } else {
      setFiltered([]);
    }
  };

  const onCancelDelete = () => {
    setConfirmDelete(false);
    setGroupToDelete("");
  };

  const onConfirmDelete = () => {
    // setConfirmDelete(false);
    // setActive(true);
    // removeGroupApi(groupToDelete)
    //   .then((res) => {
    //     getGroupApi(String(currentGroup))
    //       .then((res) => {
    //         getLinkedGroupsApi(res.data.GroupLinkID, res.data.GroupLevel)
    //           .then((res) => {
    //             setActive(false);
    //             setGroups(res.data);
    //           })
    //           .catch((err) => {
    //             setActive(false);
    //             console.log(err);
    //           });
    //       })
    //       .catch((err) => {
    //         setActive(false);
    //         console.log(err);
    //       });
    //   })
    //   .catch((err) => {
    //     setActive(false);
    //     message.error(err);
    //     console.log(err);
    //   });
  };

  useEffect(() => {
    getCompanyFuneralCustomersApi(String(currentGroup))
      .then((res) => {
        setCustomers(res.data);
        setActive(false);
      })

      .catch((err) => {
        console.log(err);
      });
  }, [currentGroup]);

  return (
    <LoadingOverlay active={isActive} spinner>
      <Layout style={{ minHeight: "100vh" }}>
        <SideBar />
        <Layout className="site-layout">
          <TopBar />
          <Content>
            <div
              style={{
                padding: 24,
                minHeight: "100%",
                background: colorBgContainer,
              }}
            >
              <h2>
                <UserOutlined
                  style={{ paddingRight: "5px", color: "#f04f05" }}
                />
                Customers
              </h2>
              <div className="interactions">
                <Button onClick={showModal} size="large">
                  <PlusOutlined style={{ paddingRight: "5px" }} />
                  Add Customer
                </Button>

                <div>
                  <Search
                    placeholder="Search"
                    size="large"
                    value={searchValue}
                    onChange={(e) => onSearch(e)}
                    style={{ width: "100%", margin: "24px 0" }}
                  />
                </div>

                {update ? (
                  <EditFuneralCustomerModal
                    show={show}
                    customer={customer}
                    showModal={showModal}
                    handleUpdate={handleUpdate}
                  />
                ) : (
                  <AddFuneralCustomerModal
                    show={show}
                    showModal={showModal}
                    handleAdd={handleAdd}
                  />
                )}
              </div>

              <FuneralCustomerTable
                customers={customers}
                filtered={filtered}
                showEditModal={showEditModal}
                handleDelete={handleDelete}
              />
            </div>
          </Content>
        </Layout>
      </Layout>

      {/* Confirmation Modal */}
      {key === "1" ? (
        <Modal
          title="Confirm Remove"
          open={confirmDelete}
          onOk={onConfirmDelete}
          onCancel={onCancelDelete}
        >
          Are you sure you want to move this Group inactive?
        </Modal>
      ) : (
        <Modal
          title="Confirm Revert"
          open={confirmDelete}
          onOk={onConfirmDelete}
          onCancel={onCancelDelete}
        >
          Are you sure you want to move this Group active?
        </Modal>
      )}
    </LoadingOverlay>
  );
};

export default FuneralCustomersPage;
